const types = {
  SET_ACTIVE_CONTRACTS: "SET_ACTIVE_CONTRACTS",
  SET_EXPIRED_CONTRACTS: "SET_EXPIRED_CONTRACTS",
  ADD_NEW_CONTRACT: "ADD_NEW_CONTRACT",
  UPDATE_CONTRACT: "UPDATE_CONTRACT",
  DELETE_CONTRACT: "DELETE_CONTRACT",
  SET_SELECTED_CONTRACT: "SET_SELECTED_CONTRACT",
  SET_POSITION_REQUEST_TYPES: "SET_POSITION_REQUEST_TYPES",
  ADD_NEW_CRT_REQUEST: "ADD_NEW_CRT_REQUEST",
  SET_INTERNAL_CRT_REQUESTS: "SET_INTERNAL_CRT_REQUESTS",
  EDIT_INTERNAL_CRT_REQUEST: "EDIT_INTERNAL_CRT_REQUEST",
  SET_EXTERNAL_CRT_REQUESTS: "SET_EXTERNAL_CRT_REQUESTS",
  SET_CRT_STATUSES: "SET_CRT_STATUSES",
};

export default types;
